// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { RangePicker } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import { NoUndefinedRangeValueType } from 'rc-picker/lib/PickerInput/RangePicker'

class DateRangePicker extends React.Component<any, any> {
  constructor(props) {
    super(props)
    this.state = {}
    this.isDayBlocked = this.isDayBlocked.bind(this)
    this.onDatesChange = this.onDatesChange.bind(this)
  }

  onDatesChange(dates: NoUndefinedRangeValueType<dayjs.Dayjs> | null) {
    if (!dates) {
      this.props.onChange({ startDate: null, endDate: null })
      return
    }

    const startDate = dayjs(dates?.[0] || this.props.startDate)
    const end = dayjs(dates?.[1] || this.props.endDate)

    const { maximumNights } = this.props

    const endDate =
      end.diff(startDate, 'days') > maximumNights
        ? startDate.add(maximumNights, 'days')
        : end

    this.props.onChange({ startDate, endDate })
  }

  isDayBlocked(day: dayjs.Dayjs, { from }: { from?: dayjs.Dayjs }) {
    const { isDayBlocked, blockFuture, maximumNights } = this.props

    const today = dayjs().endOf('day')

    if (blockFuture && day.isAfter(today)) {
      return true
    }

    if (from && Math.abs(day.diff(from, 'days')) >= maximumNights) {
      return true
    }

    if (isDayBlocked) {
      return isDayBlocked(day)
    }

    return false
  }

  render() {
    const { startDate, endDate } = this.props

    return (
      <RangePicker
        id={{ start: 'start_date_id', end: 'end_date_id' }}
        disabledDate={this.isDayBlocked}
        defaultValue={[startDate, endDate]}
        format="MMM D"
        onChange={this.onDatesChange}
        autoFocus
      />
    )
  }
}

DateRangePicker.propTypes = {
  onChange: PropTypes.func,
  maximumNights: PropTypes.number,
  blockFuture: PropTypes.bool,
  isDayBlocked: PropTypes.func,
}

export default DateRangePicker
